module.exports = __webpack_public_path__ + "img/shelfs.1aded2ef.svg";